module.exports = __webpack_public_path__ + "static/07-ece60308a67a30a00f893f7e45db174e.jpg";